import { styled } from '@mui/material';

const Section8Container = styled('section')(({ theme }) => ({
  margin: '0 auto',
  maxWidth: 1500,
  display: 'flex',
  width: '100%',
  gap: 120,
  padding: '48px 64px',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: '48px 0',
    gap: 64,
  },
  '& div.content': {
    order: 2,
    flexBasis: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      width: 526,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      order: 1,
      padding: '0 32px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
    '& div.header': {
      maxWidth: 526,
      marginBottom: 32,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 32,
      [theme.breakpoints.down('lg')]: {
        padding: '0 32px',
      },
      svg: {
        height: 100,
        width: 100,
      },
      h2: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '48px',
        color: '#04246B',
      },
    },
    p: {
      maxWidth: 526,
      fontSize: 18,
      lineHeight: '28px',
      textAlign: 'justify',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
  },
  '& div.image': {
    order: 1,
    textAlign: 'center',
    flexBasis: '50%',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    img: {
      maxWidth: 526,
      borderRadius: 16,
      height: 756,
      objectFit: 'cover',
      boxShadow: '16px 8px 48px 0px rgba(0, 0, 0, 0.25)',
      [theme.breakpoints.down('xl')]: {
        maxWidth: '100%',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        borderRadius: 0,
        height: 400,
      },
    },
  },
}));

const Section8 = () => {
  return (
    <div style={{ backgroundColor: '#F4F4F6' }}>
      <Section8Container>
        <div className="content">
          <div className="header">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="102" viewBox="0 0 100 102" fill="none">
              <circle cx="50" cy="51.5" r="48.5" stroke="#CDA07D" stroke-width="3" />
              <path
                d="M37.5 26.5H62.5C64.4891 26.5 66.3968 27.2902 67.8033 28.6967C69.2098 30.1032 70 32.0109 70 34V69C70 70.9891 69.2098 72.8968 67.8033 74.3033C66.3968 75.7098 64.4891 76.5 62.5 76.5H37.5C35.5109 76.5 33.6032 75.7098 32.1967 74.3033C30.7902 72.8968 30 70.9891 30 69V34C30 32.0109 30.7902 30.1032 32.1967 28.6967C33.6032 27.2902 35.5109 26.5 37.5 26.5ZM57.5 31.5C56.837 31.5 56.2011 31.7634 55.7322 32.2322C55.2634 32.7011 55 33.337 55 34C55 34.663 55.2634 35.2989 55.7322 35.7678C56.2011 36.2366 56.837 36.5 57.5 36.5H62.5C63.163 36.5 63.7989 36.2366 64.2678 35.7678C64.7366 35.2989 65 34.663 65 34C65 33.337 64.7366 32.7011 64.2678 32.2322C63.7989 31.7634 63.163 31.5 62.5 31.5H57.5ZM37.5 49C36.837 49 36.2011 49.2634 35.7322 49.7322C35.2634 50.2011 35 50.837 35 51.5C35 52.163 35.2634 52.7989 35.7322 53.2678C36.2011 53.7366 36.837 54 37.5 54H62.5C63.163 54 63.7989 53.7366 64.2678 53.2678C64.7366 52.7989 65 52.163 65 51.5C65 50.837 64.7366 50.2011 64.2678 49.7322C63.7989 49.2634 63.163 49 62.5 49H37.5ZM37.5 56.5C36.837 56.5 36.2011 56.7634 35.7322 57.2322C35.2634 57.7011 35 58.337 35 59C35 59.663 35.2634 60.2989 35.7322 60.7678C36.2011 61.2366 36.837 61.5 37.5 61.5H62.5C63.163 61.5 63.7989 61.2366 64.2678 60.7678C64.7366 60.2989 65 59.663 65 59C65 58.337 64.7366 57.7011 64.2678 57.2322C63.7989 56.7634 63.163 56.5 62.5 56.5H37.5ZM37.5 64C36.837 64 36.2011 64.2634 35.7322 64.7322C35.2634 65.2011 35 65.837 35 66.5C35 67.163 35.2634 67.7989 35.7322 68.2678C36.2011 68.7366 36.837 69 37.5 69H50C50.663 69 51.2989 68.7366 51.7678 68.2678C52.2366 67.7989 52.5 67.163 52.5 66.5C52.5 65.837 52.2366 65.2011 51.7678 64.7322C51.2989 64.2634 50.663 64 50 64H37.5ZM57.5 39C56.837 39 56.2011 39.2634 55.7322 39.7322C55.2634 40.2011 55 40.837 55 41.5C55 42.163 55.2634 42.7989 55.7322 43.2678C56.2011 43.7366 56.837 44 57.5 44H62.5C63.163 44 63.7989 43.7366 64.2678 43.2678C64.7366 42.7989 65 42.163 65 41.5C65 40.837 64.7366 40.2011 64.2678 39.7322C63.7989 39.2634 63.163 39 62.5 39H57.5ZM37.5 31.5C36.837 31.5 36.2011 31.7634 35.7322 32.2322C35.2634 32.7011 35 33.337 35 34V41.5C35 42.163 35.2634 42.7989 35.7322 43.2678C36.2011 43.7366 36.837 44 37.5 44H50C50.663 44 51.2989 43.7366 51.7678 43.2678C52.2366 42.7989 52.5 42.163 52.5 41.5V34C52.5 33.337 52.2366 32.7011 51.7678 32.2322C51.2989 31.7634 50.663 31.5 50 31.5H37.5Z"
                fill="#CDA07D"
              />
            </svg>
            <h2>Experience You Can Rely On</h2>
          </div>
          <p style={{ marginBottom: 40 }}>
            Navigating the real estate maze can feel overwhelming with its myriad of terms, from contingencies and
            escrows to CMA, amortization, and title insurance. Buyers can find themselves lost in a sea of due
            diligence, trying to differentiate between a buyer's market and a seller's market, or discerning the
            implications of a home's LTV ratio. This is where the value of an experienced Realtor from YourWayHome truly
            shines.
          </p>
          <p>
            Our Realtors don't just speak the language; they simplify it for you. With a deep understanding of the
            industry's intricacies, they demystify the jargon, offering clarity every step of the way. By partnering
            with a YourWayHome Realtor, you're not just gaining an agent, but a translator and guide, ensuring that
            every aspect of your sale is not just executed perfectly but is also comprehensively understood by you. In a
            realm awash with terms and clauses, let YourWayHome be your beacon of clarity.
          </p>
        </div>
        <div className="image">
          <img
            src="https://bucket.ywhdev.com/wl/?id=EQyiBSCLTnOXOHIrtN8No4BDqUp7UdwC&fmode=open"
            alt="showing a beautiful 2-storey house."
          />
        </div>
      </Section8Container>
    </div>
  );
};

export default Section8;
